import { AccessPageMeta } from '@/access/accessPageMeta'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  { heading: 'Setup' },
  {
    page: PageMeta.Businesses.List,
    title: PageMeta.Businesses.List.Title,
    icon: { icon: PageMeta.Businesses.List.Icon },
    to: PageMeta.Businesses.List.Name,
  },
  {
    page: PageMeta.JobTypes.list,
    title: PageMeta.JobTypes.list.title,
    icon: { icon: PageMeta.JobTypes.list.icon },
    to: PageMeta.JobTypes.list.name,
  },
  {
    page: PageMeta.Events.List,
    title: PageMeta.Events.List.Title,
    icon: { icon: PageMeta.Events.List.Icon },
    to: PageMeta.Events.List.Name,

    /*children: [
        {
            title: 'List',
            to: 'apps-events-list'
        },
        {
            title: 'Actions',
            to: 'apps-event-actions-list'
        },
    ]*/
  },

  /*
  {
      title: 'Calendar Setup',
      icon: { icon: 'tabler-calendar' },

      children: [
          {
              title: 'Rules',
              to: 'setup-rules-list',
          },
      ]
    },
  */
  /*{
    title: 'Rules',
    icon: { icon: 'tabler-circle-dashed-check' },
    to: 'setup-rules-list',
  },*/
  /*
  {
    title: 'User Management',
    icon: { icon: 'tabler-users' },
    children: [
        {
            title: 'User List',
            to: 'setup-users-list',
        },
        {
            title: 'User Roles',
            to: 'setup-users-roles-list',
        },
        {
            title: 'User Permissions',
            to: 'setup-users-permissions-list',
        },
    ]
  },
  */
  {
    title: 'Messages & Emails',

    //page: PageMeta.Messages.List,
    icon: { icon: 'tabler-send' },
    children: [
      {
        page: PageMeta.EmailAccounts.List,
        title: 'Email Accounts',
        icon: { icon: PageMeta.EmailAccounts.List.Icon },
        to: PageMeta.EmailAccounts.List.Name,
      },

      /*{
        page: PageMeta.Templates.List,
        title: 'Templates',
        icon: { icon: PageMeta.Templates.List.Icon },
        to: PageMeta.Templates.List.Name,
      },*/
      {
        page: PageMeta.Themes.List,
        title: 'Themes',
        icon: { icon: PageMeta.Themes.List.Icon },
        to: PageMeta.Themes.List.Name,
      },
    ],
  },
  {
    page: AccessPageMeta.MicrosoftOAuth.Settings,
    title: 'Microsoft OAuth',
    icon: { icon: PageMeta.MicrosoftOAuth.Settings.Icon },
    to: PageMeta.MicrosoftOAuth.Settings.Name,
  },
  {
    page: AccessPageMeta.GoogleConnection,
    title: 'Google',
    icon: { icon: AccessPageMeta.GoogleConnection.Icon },
    to: AccessPageMeta.GoogleConnection.Name,
  },
]
